import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { gray5 } from 'styles/global_defaults/colors';
import Spinner from 'shared/components/spinner';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

const rowStyles = css`
  min-height: 50px;
  border: 1px solid ${gray5};
  border-radius: 10px;
`;

type Props = {
  showAudioRow?: boolean;
  showTranscriptRow?: boolean;
};

const AudioTranscriptLoadingState = ({ showAudioRow = true, showTranscriptRow = true }: Props) => (
  <div>
    {showAudioRow && (
      <div css={rowStyles} className='d-flex align-items-center px-4 py-3 w-100'>
        <NvIcon className='text-gray-2' icon='audio' size='small' />
        <p className='ml-2 text-gray-2 mb-0 text-regular'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.CREATING_AUDIO_FILE()}
        </p>
        <span className='ml-2'>
          <Spinner size={halfSpacing} />
        </span>
      </div>
    )}
    {showTranscriptRow && (
      <div css={rowStyles} className={`d-flex align-items-center px-4 py-3 w-100${showAudioRow ? ' mt-2' : ''}`}>
        <NvIcon className='text-gray-2' icon='comments' size='small' />
        <p className='ml-2 text-gray-2 mb-0 text-regular'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.TRANSCRIBING_TEXT()}
        </p>
        <span className='ml-2'>
          <Spinner size={halfSpacing} />
        </span>
      </div>
    )}
  </div>
);

export default AudioTranscriptLoadingState;
